import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '../../atoms/text'
import { MyAccountBankAccountCard } from '../MyAccountBankAccountCard'
import { If } from '../../atoms/if'
import {
  StyledContainer,
  StyledEmptyMessageWrapper,
  StyledTitleWrapper,
} from './styles'
import { useTranslation } from '../../../context/translationProvider'

export const BankAccountStatusList = ({
  title,
  description,
  emptyMessage,
  items,
  isActive,
  onDelete,
  onOpenBankAccountDetails,
}) => {
  const { translate } = useTranslation()
  const tagLabel = isActive
    ? 'payments.bankAccountKeys.tags.active'
    : 'payments.bankAccountKeys.tags.inactive'

  return (
    <StyledContainer>
      <StyledTitleWrapper $isActive={isActive}>
        <Text bold style={{ fontSize: 20 }}>
          {title}
        </Text>
        <Text style={{ fontSize: 14 }}>{description}</Text>
      </StyledTitleWrapper>

      <If
        condition={items.length === 0 && emptyMessage}
        render={() => (
          <StyledEmptyMessageWrapper>
            <Text>{emptyMessage}</Text>
          </StyledEmptyMessageWrapper>
        )}
      />

      <If
        condition={items.length > 0}
        render={() => (
          <>
            {items.map((bankAccount, index) => (
              <MyAccountBankAccountCard
                key={index}
                bankAccount={bankAccount}
                active={isActive}
                tagLabel={translate(tagLabel)}
                isDefault={bankAccount?.defaultForWithdrawal}
                onDelete={onDelete}
                onClick={onOpenBankAccountDetails}
              />
            ))}
          </>
        )}
      />
    </StyledContainer>
  )
}

BankAccountStatusList.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  emptyMessage: PropTypes.string,
  items: PropTypes.array,
  isActive: PropTypes.bool,
  onDelete: PropTypes.func,
  onOpenBankAccountDetails: PropTypes.func,
}
